/*
Sohel 03/20/2023 2699762545 reset letter Maintenance Data
Ravi  03/20/2023 2699762545 Added status column
Sohel 03/23/2023 2699762545 Added letter Search Table
Sohel 03/23/2023 2699762545 Added Letter type, create by, create date column
Sohel 03/25/2023 2699762545 Search Table Payload Changes
Sohel 03/26/2023 2699762545 Category API changes
Sohel 03/26/2023 2699762545 letter code style issue
Prakash 03/27/2023 2699762545 Added font-styling table link.
Suresh Peddavoora 03/31/2023 2699762545 Added Actions menu dropdown.
Sohel 03/04/2023 2699762545 Fixed Edit Issue
Sohel 03/04/2023 2699762545 Fixed Delete popup Issue
Sohel 04/08/2023 2699762545 column name change
Guru Prasad 04/11/2023 2699762545 Added add icon to button
Ravi 04/12/2023 2699762545 Added session storage
Ravi 04/17/2023 2699762545 Added Letter in Column's title
Akhila 05/24/2024 2699762545 role access implemeneted
Ravi 05/31/2023 2699762545 changed delete popup message
Akhila 06/08/2023 2699762545 created date change to date created field and column
*/
import React, {useState, useEffect, createRef, useRef} from 'react';
import {Button, Grid, TablePagination, makeStyles} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {httpPaginationDelete, httpPaginationPost} from './../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import moment from 'moment';
import {
  fetchBasicInfoData,
  resetBasicInfo,
  fetchCreatedByDropDownData,
  resetLetterMaintenance,
  fetchDataManagerRecordUsage,
  resetLetterUsage,
} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import PageLoader from '../../../components/PageLoader';
import {
  ErrorSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from '../../../components/CustomSnackBar';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import UsageMessage from '../../../util/UsageMessage';
import OverrideRule from '../../../components/OverrideRule';
import ActionMenuItem from '../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import SaveIcon from '@material-ui/icons/Save';
import {Add} from '@material-ui/icons';
import {LETTER_MAINTENANCE} from '../../../constants/ReusableRoleAccess';
const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
    fontSize: '0.875rem !important',
    fontFamily: 'articulat-cf, sans-serif !important',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
export default function LetterMaintenanceSearchTable({
  searchData,
  setSubmit,
  submit,
  setValue,
  isPriorLetters = false,
  lettersValues,
  setTempSelectedRows,
  tempSelectedRows,
  tempUnCheckedRef,
  setLetterMaintenanceData,
  setEditExisting = () => {},
}) {
  // export default function LetterMaintenanceSearchTable({ searchData, setSubmit, submit, setValue }) {
  const [arrayLast, setArrayLast] = useState(false);
  const tableRef = createRef();
  const deletedId = useRef(null);
  const classes1 = useStyles();
  const [tstmsg, setToastMsg] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [status, setStatus] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [customError, setCustomError] = useState(false);
  // const [loading, setIsLoadingDelete] = useState(false);
  const dispatch = useDispatch();
  const {
    basicInfoData,
    isLetterFieldsLoading,
    LetterUsageData,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const {roleData} = useSelector(({role}) => role);
  const LetterMainAccess = roleData?.window?.[LETTER_MAINTENANCE]?.['LM'];
  const columns = [
    {
      title: 'Letter Code',
      field: 'letterCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            setEditExisting(true);
            dispatch(fetchBasicInfoData(rowData?.letterCode));
            setValue(1);
          }}
        >
          {rowData?.letterCode}
        </span>
      ),
    },
    {
      title: 'Letter Description',
      field: 'letterDescription',
    },
    {
      title: 'Letter Type',
      field: 'letterType',
      render: (rowData) => {
        return rowData?.letterType ? rowData?.letterType?.replace(/_/, ' ') : '';
      },
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Draft</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const LetterMaintenanceSessionStorage = JSON.parse(
    sessionStorage.getItem('searchLetterMaintenance'),
  );
  if (LetterMaintenanceSessionStorage && !submit && !isPriorLetters) {
    searchData = LetterMaintenanceSessionStorage;
  }

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  useEffect(() => {
    dispatch(resetBasicInfo());
    dispatch(fetchCreatedByDropDownData('letter'));
  }, []);
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);

  useEffect(() => {
    if (!isPriorLetters) {
      setValue(0);
      isDelete && setIsDelete(false);
    }
  }, []);
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      // dispatch(fetchCreatedByDropDownData("accountupdate"));
      setStatus(false);
    }
  }, [status]);

  const handleDelete = (rowData) => {
    dispatch(fetchDataManagerRecordUsage(rowData?.letterCode));
    setIsDelete(false);
    setDeleteUsage(true);
    deletedId.current = rowData;
  };
  const handleClose = () => {
    setIsDelete(false);
    setUserMetrixDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`newlettermaintenance/delete/${deletedId.current?.letterCode}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!isPriorLetters) {
      dispatch(resetLetterMaintenance());
    }
  }, []);

  // usage code

  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setLetterMaintenanceData(rowData);
    dispatch(fetchDataManagerRecordUsage(rowData?.letterCode));
  };

  useEffect(() => {
    if (LetterUsageData?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true);
        setTimeout(() => {
          setCustomError(false);
          dispatch(resetLetterUsage());
        }, 3000);
      }
    } else if (LetterUsageData?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        setValue(2);
      }
    }
  }, [LetterUsageData]);

  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  useEffect(() => {
    customError && setCustomError(false);
    setValue(0);
    isDelete && setIsDelete(false);
  }, []);

  // Action Menu

  const handleEdit = (rowData) => {
    setEditExisting(true);
    dispatch(fetchBasicInfoData(rowData?.letterCode));
    setValue(1);
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title={'Delete Letter'}
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Letter'} />
          ) : (
            `Are you sure you want to delete the ${deletedId.current?.letterCode} Letter ?`
          )
        }
        handleSubmit={handleDeleteUsage}
        buttonCondition={userMetrixDelete}
      />
      <OverrideRule
        dialogTitle="Delete Letter"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.letterCode || ''} - ${
          deletedId.current?.description || ''
        }  This Letter has been used in the following places.`}
        data={LetterUsageData?.placeResponse}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields actions-dropdown-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    tableData: {
                      ...row.tableData,
                      id: row.letterCode,
                    },
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter((ele) => ele?.letterCode !== row?.letterCode)
                  .map((ele) => {
                    return {
                      ...ele,
                      tableData: {
                        ...ele.tableData,
                        id: ele?.letterCode,
                      },
                    };
                  });
                setTempSelectedRows(updatedRows);
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `newlettermaintenance/search/lettermaintainance`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  letterCode: searchData?.letterCode ? searchData?.letterCode : '',
                  letterDescription: searchData?.description ? searchData?.description : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  isDraft: searchData?.isDraft?.key ? searchData?.isDraft?.key : '',
                  letterType: searchData?.letterType?.value ? searchData?.letterType?.value : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        const newObj = {};

                        if (isPriorLetters) {
                          [...lettersValues?.priorLetters, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.letterCode]) {
                              newObj[el.letterCode] = el;
                            }
                          });
                        }

                        const newRows = data?.map((elem) => {
                          if (newObj[elem.letterCode]) {
                            return {...elem, tableData: {...elem.tableData, checked: true}};
                          } else {
                            return {
                              ...elem,
                              tableData: {...elem.tableData, checked: false},
                            };
                          }
                        });
                        resolve({
                          data: newRows?.length > 0 ? newRows : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: !isPriorLetters,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: isPriorLetters,
              selectionProps: (rowData) => {
                return {
                  disabled: rowData?.letterCode === basicInfoData?.letterCode,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleUsage={handleUsage}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: true,
                    hiddenDelete: false,
                    notes: true,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !LetterMainAccess?.edit,
                    disableRun: false,
                    disableCopy: false,
                    disableDelete: !LetterMainAccess?.delete,
                    disableExecution: false,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        disabled={!LetterMainAccess?.add}
                        isFreeAction={true}
                        onClick={(event) => {
                          setValue(1);
                          dispatch(resetLetterMaintenance());
                        }}
                        startIcon={<Add />}
                      >
                        Add Letter
                      </Button>
                    }
                  </div>
                </div>
              ),
            }}
            // actions={
            //   isPriorLetters
            //     ? []
            //     : [
            //       {
            //         icon: () => <EditOutlinedIcon />,
            //         tooltip: "Edit",
            //         onClick: (event, rowData) => {
            //           dispatch(fetchBasicInfoData(rowData?.letterCode));
            //           setValue(1);
            //         },
            //       },
            //       (rowData) => {
            //         return {
            //           icon: () => (
            //             <>
            //               <DeleteOutlineOutlinedIcon />
            //             </>
            //           ),
            //           tooltip: "Delete",
            //           onClick: () => {
            //             handleDelete(rowData);
            //           },
            //         };
            //       },
            //       (rowData) => {
            //         return {
            //           icon: () => (
            //             <>
            //               <DataUsageIcon />
            //             </>
            //           ),
            //           tooltip: "Usage",
            //           onClick: () => {
            //             handleUsage(rowData);
            //           },
            //         };
            //       },
            //       {
            //         icon: () => (
            //           <>
            //             <div className="mb-1">
            //               <Button type="button" variant="outlined" className={`search-btn`}>
            //                   Add Letter
            //               </Button>
            //             </div>
            //           </>
            //         ),
            //         isFreeAction: true,
            //         onClick: () => {
            //           setValue(1);
            //           dispatch(resetLetterMaintenance());
            //         },
            //       },
            //     ]
            // }

            actions={
              isPriorLetters ?
                [] :
                [
                  {
                    icon: () => <SaveIcon />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => console.log(rowData, 'rowData'),
                  },
                ]
            }
          />
        </div>
      </Grid>
      {isLetterFieldsLoading && <PageLoader />}
      {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
      {tstmsg && <SuccessSnackbar successMsg={tstmsg} />}
      {customError && <WarningSnackbar errorMsg={`This Letter is not being used anywhere`} />}
    </>
  );
}
